// extracted by mini-css-extract-plugin
export default {"uploadAvatarDialog":"AvatarUploadDialog_uploadAvatarDialog__bTw7B"};